module.exports = __webpack_public_path__ + "img/graph-image.05d7047e.svg";